/**
 * Delivery API config for the shared Corporate + Talents space.
 * Do not reuse REACT_APP_CONTENTFUL_API_SPACE / ACCESS_TOKEN (old space).
 */
export function getContentfulDeliveryConfig() {
  const spaceId = process.env.REACT_APP_CONTENTFUL_SPACE;
  const accessToken = process.env.REACT_APP_CONTENTFUL_DELIVERY_TOKEN;
  const environment = process.env.REACT_APP_CONTENTFUL_ENV || 'master';
  const cdn = (process.env.REACT_APP_CONTENTFUL_CDN || 'https://cdn.contentful.com').replace(
    /\/$/,
    ''
  );
  if (!spaceId || !accessToken) {
    if (typeof console !== 'undefined') {
      console.warn(
        'Contentful delivery env missing (REACT_APP_CONTENTFUL_SPACE / REACT_APP_CONTENTFUL_DELIVERY_TOKEN); using local dictionaries.'
      );
    }
    return null;
  }
  return { spaceId, accessToken, environment, cdn };
}
